var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1416 10.2084V13.9584C14.1416 17.0834 12.8916 18.3334 9.7666 18.3334H6.0166C2.8916 18.3334 1.6416 17.0834 1.6416 13.9584V10.2084C1.6416 7.08337 2.8916 5.83337 6.0166 5.83337H9.7666C12.8916 5.83337 14.1416 7.08337 14.1416 10.2084Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3083 4.87496V7.62496C18.3083 9.91663 17.3916 10.8333 15.0999 10.8333H14.1416V10.2083C14.1416 7.08329 12.8916 5.83329 9.7666 5.83329H9.1416V4.87496C9.1416 2.58329 10.0583 1.66663 12.3499 1.66663H15.0999C17.3916 1.66663 18.3083 2.58329 18.3083 4.87496Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.15c561687afe8a0b1faa54a08ea2f49c.svg";
export { ForwardRef as ReactComponent };